import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import OrderView from '../views/OrderView.vue'
import InviteTeams from '../views/InviteTeams.vue'
import UserView from '../views/UserView.vue'
import AllOrder from '../views/AllOrder.vue'
import SubmitKyc from '../views/SubmitView.vue'
import ResetPwd from '../views/ResetPwdView.vue'
import WithdrawRecords from '../views/WithdrawRecords.vue';
import Statistics  from '../views/StatisticsView.vue';
import ContactTaskView from '../views/ContactTaskView.vue';
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/order',
    name: 'order',
    component: OrderView
  },
  {
    path: '/teams',
    name: 'teams',
    component: InviteTeams
  },
  {
    path: '/user',
    name: 'user',
    component: UserView
  },
  {
    path: '/allorder',
    name: 'allorder',
    component: AllOrder
  },
  {
    path: '/submitkyc',
    name: 'submitkyc',
    component: SubmitKyc
  },
  {
    path: '/resetpwd',
    name: 'resetpwd',
    component: ResetPwd
  },
    {
    path: '/withdraw-records',
    name: 'WithdrawRecords',
    component: WithdrawRecords
  },
    {
    path: '/statistics',
    name: 'Statistics',
    component: Statistics
  },
  {
    path: '/contact-task',
    name: 'contactTask',
    component: ContactTaskView
  },
  {
    path: '/contact-task-order',
    redirect: '/contact-task?tab=orders'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
